import { Box, Theme, useTheme } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import ConfigurationWrapper from '../../components/shared/ConfigurationWrapper';
import { ReactComponent as OrganisationIcon } from '../../assets/icons/Company_Organisation.svg';
import { ReactComponent as LocationIcon } from '../../assets/icons/Location.svg';
import { ReactComponent as ExternalCompaniesIcon } from '../../assets/icons/Company External.svg';
import PanelOrganisation from '../../components/configuration/organisation/PanelOrganisation';
import { useSubscriptionContext } from '../../context/SubscriptionContext';
import AlertBanner from '../../components/shared/banner/AlertBanner';
import { ExceededQuotaKey } from '../../lib/app/subscription';
import { useModuleDurationTracking } from '../../hooks/useModuleDurationTracking';
import { GroupContext } from '../../context/GroupContext';
import { CompanyContext } from '../../context/CompanyContext';

const ConfigurationOrganisation = () => {
  const { group } = useContext(GroupContext);
  const { company } = useContext(CompanyContext);

  if (!group || !company) return null;

  // Track module duration.
  useModuleDurationTracking('Configuration', 'Organisation', group.id, company.id);

  const theme: Theme = useTheme();
  const primary_blue: string = theme.palette.primary.main;
  const dark_teal: string = theme.palette.teal.dark;

  // Company subscription state.
  const { subscription, getExceededSubscriptionKeys } = useSubscriptionContext();
  const [showQuotaExceededAlert, setShowQuotaExceededAlert] = useState(false);

  const exceeded_subscription_keys: Array<ExceededQuotaKey> = getExceededSubscriptionKeys([
    'entities'
  ]);

  // Close quota reached alert message.
  const handleClose = () => {
    setShowQuotaExceededAlert(false);
  };

  // Validate subscription quota.
  useEffect(() => {
    if (exceeded_subscription_keys.length) {
      setShowQuotaExceededAlert(true);
    }
  }, [subscription]);

  return (
    <Box>
      <ConfigurationWrapper
        title="Organisation"
        icon={<OrganisationIcon height={50} fill={primary_blue} stroke={primary_blue} />}
        previous={{
          route: '/configuration/geographical',
          label: 'Geographical',
          icon: <LocationIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
        next={{
          route: '/configuration/external-companies',
          label: 'External Companies',
          icon: <ExternalCompaniesIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
      >
        <AlertBanner
          severity="warning"
          message={`Quota reached for ${exceeded_subscription_keys
            .map((item) => `${item.label} (${subscription?.quota[item.key]})`)
            .join(', ')} allocated to your subscription.`}
          open={showQuotaExceededAlert && !!exceeded_subscription_keys.length}
          action={handleClose}
        />
        <PanelOrganisation />
      </ConfigurationWrapper>
    </Box>
  );
};

export default ConfigurationOrganisation;
